/* const selectedQuantity = this._getCount();
let format = document.querySelector("body").getAttribute("data-format");
let stickyRegularPrice = document.querySelectorAll(".sticky-bar__price-regular");
stickyRegularPrice.forEach((el) => {
  el.innerHTML = Shopify.formatMoney(el.dataset.price * selectedQuantity, format); */

if (!customElements.get('product-subscription-widget')) {
  customElements.define(
    'product-subscription-widget',
    class ProductSubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('.shopify-section') || this.closest('.product');
        this.getVariantData();
        const formId = this.dataset.formId;
        this.productForm = document.querySelector(`#${formId}`);
        this.selector = this.querySelector('select');
        // loop through all options within this.selector and sort the options alphabetically based on the option value
        const options = Array.from(this.selector.querySelectorAll('option'));

        // disabled the sort fun . options will be sorted from recharge
        // options.sort((a, b) => {
        //   if (a.value < b.value) {
        //     return -1;
        //   } else if (a.value > b.value) {
        //     return 1;
        //   } else {
        //     return 0;
        //   }
        // });
        options.forEach((option) => {
          this.selector.appendChild(option);
        });
        //

        // Watch for variant selection to update selling plan option selectors
        this.productForm.addEventListener('change', this.onVariantChange.bind(this));

        // Watch for selling plan option change to update the selected selling plan
        this.querySelectorAll('select').forEach((optionSelector) => {
          optionSelector.addEventListener('change', this.onSellingPlanChange.bind(this));
        });

        this.querySelectorAll('[data-purchase-option-input]').forEach((optionSelector) => {
          optionSelector.addEventListener('change', this.onPurchaseOptionsChange.bind(this));
        });
        document.addEventListener('product:form:update', this.onProductFormUpdate.bind(this));

        this.onPurchaseOptionsChange();
        this.onVariantChange();
        this.onSellingPlanChange();
        // name="selling_plan" on window load
        window.addEventListener('load', () => {
          this.onSellingPlanChange();
        });
      }

      onProductFormUpdate(event) {
        const { detail } = event;
        let format = document.querySelector('body').getAttribute('data-format');
        const { sellingPlanId, price, compare_at_price, subscriptionDiscountCents, subscriptionsPirce } = detail;
        document.querySelectorAll('.js-subscriptions-final-price').forEach((el) => {
          el.innerHTML = Shopify.formatMoney(subscriptionsPirce, format);
        });
        document.querySelectorAll('.js-one-time-price ').forEach((el) => {
          el.innerHTML = Shopify.formatMoney(price, format);
        });
        document.querySelectorAll('.js-subscription-save').forEach((el) => {
          el.innerHTML = Shopify.formatMoney(subscriptionDiscountCents, format);
          if (subscriptionDiscountCents === 0) {
            el.parentElement.style.display = 'none';
          } else {
            el.parentElement.style.display = 'block';
          }
        });
      }

      getVariantData() {
        // based on how the theme is passing the data, this may need to be updated

        /* // this is for dawn theme
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData; */

        // start get variant data from section for Empire theme
        const dataEl = this.section.querySelector('[data-section-data]');
        if (!dataEl) return {}; // Load data from attribute, or innerHTML

        const data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
        try {
          this.variantData = JSON.parse(data).product.variants;
          return this.variantData;
        } catch (error) {
          console.warn(`Sections: invalid section data found. ${error.message}`);
          return {};
        }
        // end get variant data from section for Empire theme
      }

      findSelectedVariant() {
        var selectedVariantId = parseInt(this.section.querySelector('[name="id"]').value);
        var selectedVariant;

        for (var i = 0; i < this.variantData.length; i++) {
          if (this.variantData[i].id === selectedVariantId) {
            selectedVariant = this.variantData[i];
            break;
          }
        }

        return selectedVariant;
      }

      onSellingPlanChange() {
        this.isSubscription = this.section.querySelector('[data-purchase-option-input][value="subscription"]').checked;
        var selectedVariant = this.findSelectedVariant();
        var availableSellingPlanAllocations = selectedVariant.selling_plan_allocations;
        //console.log('availableSellingPlanAllocations', availableSellingPlanAllocations);
        for (var i = 0; i < availableSellingPlanAllocations.length; i++) {
          var sellingPlan = availableSellingPlanAllocations[i];

          if (this.selector.value == sellingPlan.selling_plan_id) {
            this.selectedSellingPlanId = sellingPlan.selling_plan_id;
            this.selectedSellingPlanAllocation = sellingPlan;
          }
        }

        if (this.isSubscription) {
          this.section
            .querySelectorAll('[name="selling_plan"]')
            .forEach((el) => (el.value = this.selectedSellingPlanId));
        } else {
          this.section.querySelectorAll('[name="selling_plan"]').forEach((el) => (el.value = ''));
        }

        // dispatch global event and add this.selectedSellingPlanAllocation.selling_plan_id & this.selectedSellingPlanAllocation.price
        // and this.selectedSellingPlanAllocation.compare_at_price
        const subscriptionDiscountCents =
          this.selectedSellingPlanAllocation.compare_at_price - this.selectedSellingPlanAllocation.price;
        const event = new CustomEvent('product:form:update', {
          detail: {
            sellingPlanId: this.selectedSellingPlanId,
            compare_at_price: this.dataset.isHamper
              ? parseFloat(this.dataset.compareAtPrice)
              : selectedVariant.compare_at_price,
            price: this.dataset.isHamper ? parseFloat(this.dataset.price) : selectedVariant.price,
            subscriptionsPirce: this.dataset.isHamper
              ? parseFloat(this.dataset.price - subscriptionDiscountCents)
              : this.selectedSellingPlanAllocation.price,
            subscriptionCompareAtPrice: this.dataset.isHamper
              ? parseFloat(this.dataset.price)
              : this.selectedSellingPlanAllocation.compare_at_price,
            subscriptionDiscountCents: subscriptionDiscountCents,
            isSubscription: this.isSubscription,
          },
        });
        document.dispatchEvent(event);
      }

      onVariantChange() {
        var selectedVariant = this.findSelectedVariant();
        var availableSellingPlanAllocations = selectedVariant.selling_plan_allocations;
        console.log('availableSellingPlanAllocations', availableSellingPlanAllocations);
        // Update the selling plan option selectors based on the available selling plan allocations
        // for the selected variant
        //this.selectedSellingPlanAllocation = availableSellingPlanAllocationsfind((sellingPlanAllocation) => sellingPlanAllocation
        this.selector.querySelectorAll('option').forEach(function (option, index) {
          option.disabled = true;
        });
        availableSellingPlanAllocations.forEach((sellingPlanAllocation) => {
          var option = this.selector.querySelector(`option[value="${sellingPlanAllocation.selling_plan_id}"]`);
          if (option) {
            option.disabled = false;
          }
        });
        this.onSellingPlanChange();
      }

      onPurchaseOptionsChange() {
        this.onSellingPlanChange();
      }
    }
  );
}
